import { render, staticRenderFns } from "./ImportDid.vue?vue&type=template&id=33c12390&"
import script from "./ImportDid.vue?vue&type=script&lang=js&"
export * from "./ImportDid.vue?vue&type=script&lang=js&"
import style0 from "./ImportDid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportDid.vue"
export default component.exports